import { BigNumber } from "shared/cubiq-model-multi-asset";

import { Long } from "shared/cubiq-model-multi-asset";

import { ICellAdapter } from "./ICellAdapter";

import { NumericAdapter } from "./NumericAdapter";

import { ColumnDefinition } from "../model/ColumnDefinition";

// String types that are sortable as an Int32 in C++ module
export class EnumAdapter extends NumericAdapter {
  constructor() {
    super();
  }

  // @Override
  adapt(column: ColumnDefinition, row: any, ...modelObjects: Array<any>): void {
    // Nesting within modelObject should be applied in a more specific adapter

    row[column.data] = this.retrieveData(modelObjects[0], column.data);
    row[column.sortKey] = this.retrieveSort(modelObjects[0], column.data);
    row[column.filterKey] = this.retrieveFilter(modelObjects[0], column.data);

    if (column.hasSearchKey) {
      row[column.searchKey] = String(row[column.data]);
    }
  }

  retrieveFilter(order: any, columnProperty: string): string {
    return null;
  }
}
